import Vue from "vue";
import VueRouter from "vue-router";
import Store from "../store";

import admin from "../views/admin/routes";

//import mchthd from "../views/customers/mchthd/routes";
//import mchthe from "../views/customers/mchthe/routes";
import financemission from "../views/customers/pblevents/routes";
import diakonissen from "../views/customers/diakonissen/routes";
import blpk from "../views/customers/blpk/routes";
import clinam from "../views/customers/clinam/routes";
import hunziker from "../views/customers/hunziker/routes";
import pblmzr from "../views/customers/pblmzr/routes";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/login.vue"),
    meta: { pageTitle: "Login", type: "system" },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
    meta: { pageTitle: "Login", type: "system" },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/logout.vue"),
    meta: { pageTitle: "Logout", type: "system" },
  },
].concat(admin, financemission, blpk, clinam, hunziker, diakonissen, pblmzr);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  let catched = false;
  if (to.matched.some((record) => record.meta)) {
    if (to.meta.requiresRole) {
      if (!Store.state.Auth.user || (to.meta.requiresRole && Store.state.Auth.user.role && !to.meta.requiresRole.includes(Store.state.Auth.user.role))) {
        catched = true;
        next({
          path: "/login",
          query: { redirect: to.fullPath },
        });
      } else if (Store.state.Auth.user.role != "admin" && to.meta.customer && !Store.state.Auth.user.customer.includes(to.meta.customer)) {
        catched = true;
        next({
          path: "/login",
          query: { redirect: to.fullPath },
        });
      }
    }
    if (to.meta.requiresVisitor) {
      let loc = JSON.parse(localStorage.getItem("s4all-loc") || "{}");

      if (!loc.visitorKeys || (loc.visitorKeys && !loc.visitorKeys.includes(to.meta.requiresVisitor))) {
        catched = true;
        next({
          path: `${to.path}/visitor`,
          query: { redirect: to.fullPath },
        });
      }
    }
  }

  if (!catched) {
    next();
  }
});

export default router;
